<template lang="pug">
    div(class="flex h-full items-center border-b-2 p-3 xs:px-4 md:block md:text-center md:py-4 xl:flex xl:px-0 xl:py-5 xl:text-left")
        div
            slot(name="left")

        div(class="mx-3 text-xs xs:ml-5 xs:mr-auto md:mx-5 md:mt-1 md:mb-2 md:text-base xl:my-0 xl:text-sm")
            slot(name="center")

        div
            slot(name="button")

</template>

<script>
export default {
    name: 'SameDayShippingItem',
}
</script>
